import React from 'react'
// import PropTypes from 'prop-types'
import EntitiesLogin from '../../components/Login/EntitiesLogin'
import { navigate } from 'gatsby';

const EntitiesLoginPage = props => {
    const handleClickRememberPass = () => navigate("/entidades/recordar");
    return (
        <EntitiesLogin
            onRecoveryBtn={handleClickRememberPass}
        />
    )
}

EntitiesLoginPage.propTypes = {}

export default EntitiesLoginPage